import bus from '../connection/storeManagerConnection';
import store from '../store';
import {
    closeSession,
    fetchCartsLocations,
    fetchSessions,
    setDevicesLoading,
    updateCartLocation,
    updateCustomerLabels,
    updateDevice,
    updateDeviceLocations,
    updateTicket,
    updateWeights,
} from './sessionMonitor.action';
import {
    addTaraChange,
    addTicketChange,
    sessionManualCheck,
    sessionScaleTrigger,
    sessionWeightDeviation,
    sessionWeightWithoutScan,
} from './sessionMonitorDetails.action';
import { CustomerPropertiesChangedNotification } from '@whiz-cart/node-shared/models/customer/customerPropertiesChangedNotification';
import { CustomerTicket } from '@whiz-cart/node-shared/models/ticket/ticket';

export default () => [
    bus.onConnection(
        () => {
            if (!bus.config.storeGuid) return [];
            store.dispatch(fetchCartsLocations(bus.config.storeGuid));
            store.dispatch(fetchSessions(bus.config.storeGuid));
        },
        (loading) => store.dispatch(setDevicesLoading(loading)),
    ),

    bus.subscribe('storeSessionStart', (msg) => {
        // TODO: parse msg
        store.dispatch(updateDevice(msg as any));
    }),

    bus.subscribe('storeSessionTransferCompleted', (msg) => {
        // TODO: parse msg
        store.dispatch(updateDevice(msg as any));
    }),

    bus.subscribe('storeSessionEnd', (msg) => {
        // TODO: parse msg
        store.dispatch(closeSession(msg as any));
    }),

    bus.subscribe('deviceLocationUpdated', (msg) => {
        // TODO: parse msg
        store.dispatch(updateDeviceLocations([msg]));
    }),

    bus.subscribe('deviceLocationBatchUpdate', (msg) => {
        // TODO: parse msg
        store.dispatch(updateDeviceLocations(msg));
    }),

    bus.subscribe('ticketCreated', CustomerTicket, (msg) => {
        store.dispatch(updateTicket(msg));
        store.dispatch(addTicketChange(msg));
    }),

    bus.subscribe('ticketChanged', CustomerTicket, (msg) => {
        store.dispatch(updateTicket(msg));
        store.dispatch(addTicketChange(msg));
    }),

    bus.subscribe('sessionMonitor_admin', CustomerTicket, (msg) => {
        store.dispatch(updateTicket(msg));
        store.dispatch(addTicketChange(msg));
    }),

    bus.subscribe('storeSessionTara', (item: any) => {
        // TODO: parse item
        store.dispatch(updateWeights({ ...item, ...item.tara, t: item.createdOn }));
        store.dispatch(addTaraChange(item));
    }),

    bus.subscribe('sessionScaleTrigger', (item: any) => {
        // TODO: parse item
        store.dispatch(updateWeights({ ...item, t: item.createdOn }));
        store.dispatch(sessionScaleTrigger(item));
    }),

    bus.subscribe('sessionWeightWithoutScan', (item: any) => {
        // TODO: parse item
        store.dispatch(updateWeights({ ...item, t: item?.model?.createdOn }));
        store.dispatch(sessionWeightWithoutScan(item));
    }),

    bus.subscribe('sessionWeightDeviation', (item: any) => {
        // TODO: parse item
        store.dispatch(updateWeights({ ...item, t: item.createdOn }));
        store.dispatch(sessionWeightDeviation(item));
    }),

    bus.subscribe('sessionManualCheck', (item) => {
        // TODO: parse item
        store.dispatch(sessionManualCheck(item));
    }),

    bus.subscribe('deviceExpectedWeightUpdated', (item: any) => {
        // TODO: parse item
        store.dispatch(
            updateWeights({
                sessionGuid: item.sessionGuid,
                t: item.weight?.ts,
                expectedWeight: item.weight?.weight,
            }),
        );
    }),

    bus.subscribe('deviceActualWeightUpdated', (item: any) => {
        // TODO: parse item
        store.dispatch(
            updateWeights({
                sessionGuid: item.sessionGuid,
                t: item.weight?.ts,
                actualWeight: item.weight?.weight,
            }),
        );
    }),

    bus.subscribe('customerPropertiesChanged', CustomerPropertiesChangedNotification, (msg) => {
        store.dispatch(updateCustomerLabels(msg.customerGuid, msg.properties.labels ?? []));
    }),

    bus.subscribe('cartLocationUpdated', (msg: any) => {
        store.dispatch(updateCartLocation(msg));
    }),
];
